enum TextButtonTheme {
  Green = "Green",
  GreenDark = "GreenDark",
  YellowLight = "YellowLight",
}

export default TextButtonTheme;
